import React from "react";
import GaugeChart from "react-gauge-chart";
import "./data.css";

function DataVelocity(props) {
  let center = {
    display: "flex",
    justifyContent: "center",
  };
  return (
    <div>
      <div className="data-page">
        {/* <div className="temperature">temp here</div> */}
        <div className="right-box">
          {/* <div className="orientation-box">
            <iframe
              src="https://solarsystem.nasa.gov/gltf_embed/2378"
              style={{ height: "200px", width: "300px" }}
              title="Iframe Example"
            ></iframe>
          </div> */}
          <div className="angular-velocity">
            <div className="angular-container" style={center}>
              <GaugeChart
                id="gauge-chart1"
                percent={props.humidity * 0.01}
                nrOfLevels={30}
                colors={["#E7E7E7", "green"]}
                textColor="green"
                needleColor="rgba(111, 231, 229, 0.548)"
                needleBaseColor="#3FE2DC"
              />
            </div>
            <span style={center}>Humidity</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DataVelocity;
